import axios from "axios";
import Vue from "vue";
import {updateFileState} from "@frontend/store/figma-layers/helpers/update-file-state";
import {FigmaRootContainer} from "@/includes/fig-parser/models/figma-root";
import {FigStrategy} from "@frontend/group/modules/fig-layers/strategy";
import {recursiveFind, recursiveWalker} from "@frontend/group/modules/fig-layers/helpers";
import {FIG_PARSED_FIELD_TYPES} from "@/includes/fig-parser/constants";
import {
  FIELD_TYPE_BACKGROND_THEME_IMAGE,
  FIELD_TYPE_MULTI_LINE_TEXT, FIELD_TYPE_RECTANGLE
} from "@frontend/constants/type-fields-of-template";
import _ from "lodash";

const initialState = () => ({
  files: [],
  currentFileIndex: 0,
  isReparse: false,
  flow: FigStrategy.FLOWS.PARSE,
  isImporting: false,
});

const initialFileStateData = {
  data: null,
  isFetching: false,
}

const initialFileState = (args) => ({
  ...initialFileStateData,
  ...args,
});

export const MUTATIONS = {
  SET_FLOW: 'SET_FLOW',
  SET_IS_IMPORTING: 'SET_IS_IMPORTING',
  FILE: {
    INIT_STATE: 'FILE_INIT_STATE',
    SET_DATA: 'FILE_SET_DATA',
    SET_IS_FETCHING: 'FILE_SET_IS_FETCHING',
    UPDATE_LAYER: 'FILE_UPDATE_LAYER',
    TOGGLE_LAYER: 'FILE_TOGGLE_LAYER'
  }
};


export default {
  namespaced: true,
  state: initialState(),
  getters: {
    files: state => state.files,
    flow: state => state.flow,
    isImporting: state => state.isImporting,
    currentFileIndex: state => state.currentFileIndex,
    currentFile: state => state.files[state.currentFileIndex]
  },
  mutations: {
    [MUTATIONS.SET_FLOW](state, payload) {
      state.flow = payload;
    },
    [MUTATIONS.SET_IS_IMPORTING](state, payload) {
      state.isImporting = payload;
    },
    [MUTATIONS.FILE.INIT_STATE](state, { payload, index }) {
      Vue.set(state.files, index, payload);
    },
    [MUTATIONS.FILE.SET_DATA](state, { payload, index }) {
      const updater = (fileState) => fileState.data = payload;

      updateFileState({ state, index, updater });
    },
    [MUTATIONS.FILE.UPDATE_LAYER](state, { index, layer, key, value }) {
      const updater = (fileState) => {
        const _layer = recursiveFind(fileState.data.tree, _layer => _layer.uuid === layer.uuid);

        if (_layer) {
          _.set(_layer, key, value);
        }
      };

      updateFileState({ state, index, updater });
    },
    [MUTATIONS.FILE.TOGGLE_LAYER](state, { index, layer }) {
      
    },
    [MUTATIONS.FILE.SET_IS_FETCHING](state, { payload, index }) {
      const updater = (fileState) => fileState.isFetching = payload;

      updateFileState({ state, index, updater });
    },
  },
  actions: {
    async loadFiles({dispatch, state, commit}, _files) {
      const files = Array.isArray(_files) ? _files : [_files];

      for (let index = 0; index < files.length; index++) {
        const file = files[index];

        commit(MUTATIONS.FILE.INIT_STATE, {
          index,
          payload: initialFileState({
            id: file.id,
            filename: file.url,
            originalFileName: `${file.name}.psd`,
            isFetching: true,
          })
        });
        
        const response = await axios.post('/file/preview_figma_file', {
          filename: file.url,
          originFileName: `${file.name}.fig`,
          isReparse: true,
        });

        commit(MUTATIONS.FILE.SET_DATA, { index: index, payload: new FigmaRootContainer(response.data) });

        /**
         * BETA AUTOMAP
         */
        recursiveWalker(state.files[index].data.tree, node => {
          if (!node.data.visible) {
            return;
          }

          const map = {
            [FIG_PARSED_FIELD_TYPES.IMAGE]: FIELD_TYPE_BACKGROND_THEME_IMAGE,
            [FIG_PARSED_FIELD_TYPES.TEXT]: FIELD_TYPE_MULTI_LINE_TEXT,
            [FIG_PARSED_FIELD_TYPES.RECTANGLE]: FIELD_TYPE_RECTANGLE
          }
          commit(MUTATIONS.FILE.UPDATE_LAYER, {  index, layer: node, key: 'fieldType', value: map[node.type] ?? null });
        })
        commit(MUTATIONS.FILE.SET_IS_FETCHING, { index, payload: false });
      }
    },
    toggleLayer({ getters, commit }, layer) {
      recursiveWalker(getters.currentFile.data.tree, node => {
        if (node.uuid === layer.uuid) {
          commit(MUTATIONS.FILE.UPDATE_LAYER, { index: getters.currentFileIndex, layer: node, key: 'data.visible', value: !node.data.visible });

          if (node.data.visible) {
            let _node = node.parent;

            while (_node) {
              _node.data.visible = true;
              _node = _node.parent;
            }
          }

          if (node.children) {
            recursiveWalker(
              node.children,
              _node => {
                commit(MUTATIONS.FILE.UPDATE_LAYER, { index: getters.currentFileIndex, layer: _node, key: 'data.visible', value: node.data.visible });
              }
            )
          }
        }
      })
    },
    async handleTemplatesImport({ commit, state }) {
      commit(MUTATIONS.SET_IS_IMPORTING, true);
      await FigStrategy.run(state.flow, { state });
      commit(MUTATIONS.SET_IS_IMPORTING, false);
    }
  }
}
